import React, { useContext } from 'react';

export type CampaignContext = {
    readonly preventCampaignBadge: boolean;
};

const Ctx = React.createContext<CampaignContext>({ preventCampaignBadge: false });

export const CampaignProvider = Ctx.Provider;
export const CampaignConsumer = Ctx.Consumer;

export function useCampaignContext(): CampaignContext {
    return useContext(Ctx);
}
